export class RolesManager {
  static userIsSuperAdmin = (roles) => {
    return roles.includes("ROLE_SUPER_ADMIN");
  };

  static userIsAdmin = (roles) => {
    return roles.includes("ROLE_ADMIN") || this.userIsSuperAdmin(roles)
  };

  static userIsProfessional = (roles) => {
    return roles.includes("ROLE_HEALTHCARE") || this.userIsAdmin(roles)
  }

  static userIsContentCreator = (roles) => {
    return roles.includes("ROLE_CONTENT_MANAGER") || this.userIsProfessional(roles)
  };
}